// extracted by mini-css-extract-plugin
module.exports = {"Notification":"notification_Notification__jOTKG","VersionNumber":"notification_VersionNumber__ZKLGm"};